import { useState } from "react";
import { Box } from "@mui/material";
import { appBackgroundColor } from "../../theme";
import { uiNeutrals } from "../../constants/uiNeutrals";
import { getRestaurantItem } from "../../utils/restaurantItems";

/** Inner clip circle as a share of the outer bordered circle. */
const CIRCULAR_LOGO_INSET_RATIO = 0.85;
/** Logo graphic inside the inner circle (smaller than the clip). */
const CIRCULAR_LOGO_IMAGE_SCALE = 1;

// Brand logo mapping
export const brandLogoMapping = {
  "Aroi Thai": "/assets/logos/Aroi_Thai.png",
  BananaBro: "/assets/logos/Banana_Bro.png",
  "Domino's Pizza": "/assets/logos/Dominos_Pizza.png",
  "Fei Fan Hotpot": "/assets/logos/Fei_Fan_Hotpot.png",
  "Genki Sushi": "/assets/logos/Genki_Sushi.png",
  "Kafe Ruuma": "/assets/logos/Kafe_Ruuma.png",
  "McDonald's": "/assets/logos/McDonalds.png",
  "Pizza Hut": "/assets/logos/Pizza_Hut.png",
  "SOI 55": "/assets/logos/SOI_55.png",
  Subway: "/assets/logos/Subway.png",
  "Sushi Zanmai": "/assets/logos/Sushi_Zanmai.png",
  "Taco Bell": "/assets/logos/Taco_Bell.png",
  "Texas Chicken": "/assets/logos/Texas_Chicken.png",
  "TGI Fridays": "/assets/logos/TGI_Fridays.png",
  "The Chicken Rice Shop": "/assets/logos/The_Chicken_Rice_Shop.png",
  "The Social": "/assets/logos/The_Social.png",
  "WAY Modern Chinois": "/assets/logos/Way_Modern_Chinois.png",
  "Bar B Q Plaza": "/assets/logos/Bar_B_Q_Plaza.png",
  "Yak Yim Thai Kitchen": "/assets/logos/Yak_Yim_Thai_Kitchen.png",
  "The Manhattan FISH MARKET": "/assets/logos/The_Manhattan_FISH_MARKET.png",
  "Salad Atelier": "/assets/logos/Salad_atelier.png",
  "Chakri Palace Thai Cuisine": "/assets/logos/Chakri_Palace_Thai_Cuisine.png",
  "Uncle Roger": "/assets/logos/Uncle_Roger.png",
  "Uncle Don's": "/assets/logos/Uncle_Don's.png",
  "The Brew House": "/assets/logos/Brew_House.png",
  "House of Pok": "/assets/logos/House_of_Pok.png",
  "Torii Teppanyaki": "/assets/logos/Torii_Tepanyaki.png",
  "Suki-Ya": "/assets/logos/Suki-Ya.png",
  "Family Mart": "/assets/logos/Family_Mart.png",
  FamilyMart: "/assets/logos/Family_Mart.png",
  "Giglio Lalaport": "/assets/logos/Giglio_Lalaport.png",
  "Kayapu Seafood Solaris": "/assets/logos/Kayapo_Seafood_Solaris.png",
  "BHC Chicken": "/assets/logos/BHC_Chicken.png",
  "Bimba Cafe": "/assets/logos/Bimba_Cafe.png",
  "Kenny Rogers Roasters": "/assets/logos/Kenny_Rogers_Roasters.png",
  myBurgerLab: "/assets/logos/myBurgerLab.png",
  "Rocku Yakiniku": "/assets/logos/Rocku_Yakiniku.png",
  "To Meet Western Cafe & Bistro":
    "/assets/logos/To_Meet_Western_Cafe_&_Bistro.png",
  "Ah Cheng Laksa": "/assets/logos/Ah_Cheng_Laksa.png",
  "Ah Yip Herbal Soup": "/assets/logos/Ah_Yip_Herbal_Soup.png",
  "AnMour Cafe": "/assets/logos/AnMour_Cafe.png",
  "Come True Cafe": "/assets/logos/Come_True_Cafe.png",
  DubuYo: "/assets/logos/DubuYo.png",
  "La Chica": "/assets/logos/La_Chica.png",
  "Mr Tuk Tuk": "/assets/logos/Mr_Tuk_Tuk.png",
  "Sho Shin Izakaya": "/assets/logos/Sho_Shin_Izakaya.png",
  "Ate Tea Cafe": "/assets/logos/Ate_Tea_Cafe.png",
  Starbucks: "/assets/logos/Starbucks.png",
  "Gong Cha": "/assets/logos/Gong_Cha.png",
  "ZUS Coffee": "/assets/logos/ZUS_Coffee.png",
  "7-ELEVEN": "/assets/logos/7-ELEVEN.png",
  "Kampung Dining Signature": "/assets/logos/Kampung_Dining_Signature.png",
  "Khan Baba": "/assets/logos/Khan_Baba.png",
  "Mido Korean BBQ": "/assets/logos/Mido_Korean_BBQ.png",
  "The Indian Gate Restaurant": "/assets/logos/The_Indian_Gate_Restaurant.png",
  "Alora Spices": "/assets/logos/Alora_Spices.png",
  "Wong Kok": "/assets/logos/Wong_Kok.png",
  "Thong Kee Cafe": "/assets/logos/Thong_Kee_Cafe.png",
  "WaaronKuus Cafe": "/assets/logos/WaaronKuus_Cafe.png",
  "A'Decade": "/assets/logos/A'Decade.png",
  "Teh Tarik Club": "/assets/logos/Teh_Tarik_Club.png",
  "Teh Tarik Place": "/assets/logos/Teh_Tarik_Place.png",
  "Tony Roma's": "/assets/logos/Tony_Roma's.png",
  "Traffic Bean": "/assets/logos/Traffic_Bean.png",
  "Pause Cafe": "/assets/logos/Pause_Cafe.png",
  "Dunkin' Donuts": "/assets/logos/Dunkin'_Donuts.png",
  "Dunkin'": "/assets/logos/Dunkin'_Donuts.png",
  "The Coffee Bean & Tea Leaf": "/assets/logos/The_Coffee_Bean_&_Tea_Leaf.png",
  KOI: "/assets/logos/KOI.png",
  "KOI Thé": "/assets/logos/KOI.png",
  "Famous amos": "/assets/logos/Famous_amos.png",
  "Famous Amos": "/assets/logos/Famous_amos.png",
  "Burger King": "/assets/logos/Burger_King.png",
  "KyoChon Chicken": "/assets/logos/KyoChon_Chicken.png",
  "Bask Bear": "/assets/logos/Bask_Bear.png",
  CHAGEE: "/assets/logos/CHAGEE.png",
  "Gigi Coffee": "/assets/logos/Gigi_Coffee.png",
  "Ichiban Ramen": "/assets/logos/Ichiban_Ramen.png",
  "Inside Scoop": "/assets/logos/Inside_Scoop.png",
  KFC: "/assets/logos/KFC.png",
  "llao llao": "/assets/logos/llaollao.png",
  "Nando's Malaysia": "/assets/logos/Nando's.png",
  "Oriental Kopi": "/assets/logos/Oriental_Kopi.png",
  Tealive: "/assets/logos/Tealive.png",
  "Baskin Robbins": "/assets/logos/Baskin_Robbins.png",
  BEUTEA: "/assets/logos/BEUTEA.png",
  "Bungkus Kaw Kaw": "/assets/logos/Bungkus_Kaw_Kaw.png",
  "GO Noodle House": "/assets/logos/GO_Noodle_House.png",
  Marrybrown: "/assets/logos/Marrybrown.png",
  "Penang Chendul": "/assets/logos/Penang_Chendul.png",
  EatBBQ: "/assets/logos/EatBBQ.png",
  "Beauty in The Pot": "/assets/logos/Beauty_in_The_Pot.png",
  "Juice Works": "/assets/logos/Juice_Works.png",
  "Morganfield's": "/assets/logos/Morganfield's.png",
  myPizzaLab: "/assets/logos/myPizzaLab.png",
  "Piccoli Lotti": "/assets/logos/Piccoli_Lotti.png",
  "SHABU-YO": "/assets/logos/SHABU-YO.png",
  Dome: "/assets/logos/Dome.png",
  IPPUDO: "/assets/logos/IPPUDO.png",
  "Hot Bird": "/assets/logos/Hot_Bird.png",
  IKEA: "/assets/logos/IKEA.png",
  "Wall's": "/assets/logos/Wall's.png",
  Yolé: "/assets/logos/Yolé.png",
  "Luckin Coffee": "/assets/logos/Luckin_Coffee.png",
  "CU Mart": "/assets/logos/CU_Mart.png",
  Woodfire: "/assets/logos/Woodfire.png",
  "SF Coffee": "/assets/logos/SF_Coffee.png",
  ChaPanda: "/assets/logos/ChaPanda.png",
  "A&W": "/assets/logos/A&W.png",
  "J.CO Donuts & Coffee": "/assets/logos/J.CO_Donuts_and_Coffee.png",
  "Richeese Factory": "/assets/logos/Richeese_Factory.png",
  "Churros+": "/assets/logos/Churros+.png",
  "Oh Cha Matcha": "/assets/logos/Oh_Cha_Matcha.png",
  "Kenangan Coffee": "/assets/logos/Kenangan_Coffee.png",
  Coolblog: "/assets/logos/Coolblog.png",
  "Secret Recipe": "/assets/logos/Secret_Recipe.png",
  "Yomie's Rice x Yogurt": "/assets/logos/Yomie's_Rice_x_Yogurt.png",
  Dáo: "/assets/logos/Dao.png",
  "Stuff'd": "/assets/logos/Stuffd.png",
  "Daily Coffee": "/assets/logos/Daily_Coffee.png",
  "Dragon Hot Pot": "/assets/logos/Dragon_Hot_Pot.png",
  "Ai-CHA Ice Cream & Tea": "/assets/logos/Ai-CHA_Ice_Cream_&_Tea.png",
  "HWC Coffee": "/assets/logos/HWC_Coffee.png",
  "Warabimochi Kamakura": "/assets/logos/Warabimochi_Kamakura.png",
  GrabFood: "/assets/logos/GrabFood.png",
  Mykori: "/assets/logos/Mykori.png",
  emart24: "/assets/logos/emart24.png",
  "Auntea Jenny": "/assets/logos/Auntea_Jenny.png",
  "Tim Hortons": "/assets/logos/Tim_Hortons.png",
  "Mokky's Pizza": "/assets/logos/Mokky's_Pizza.png",
  "Nasken Coffee": "/assets/logos/Nasken_Coffee.png",
  "KK MART": "/assets/logos/KK_Mart.png",
  foodpanda: "/assets/logos/foodpanda.png",
  "Tony's New York Pizza": "/assets/logos/Tony's_New_York_Pizza.png",
  Zenders: "/assets/logos/Zenders.png",
  BingXue: "/assets/logos/BingXue.png",
  "O'cha": "/assets/logos/O'cha.png",
  Komugi: "/assets/logos/Komugi.png",
  "OGA Tea & Dining": "/assets/logos/OGA_Tea_&_Dining.png",
  "Potato Corner": "/assets/logos/Potato_Corner.png",
};

const RestaurantItemImage = ({
  restaurantName,
  size = 60,
  borderRadius = "8px",
  sx = {},
  imageUrl,
  useDefaultFallback = true,
  loading = "lazy", // "lazy" | "eager" | undefined
  ...props
}) => {
  const defaultItemSrc = useDefaultFallback
    ? getRestaurantItem(restaurantName)
    : undefined;
  const [failed, setFailed] = useState(false);
  const [logoLoaded, setLogoLoaded] = useState(false);

  // Check for brand logo first, then use provided imageUrl, then default
  const brandLogo = brandLogoMapping[restaurantName];
  const resolvedSrc = brandLogo || imageUrl || defaultItemSrc;
  const hasLogo = Boolean(resolvedSrc && !failed);

  const logoCanvasBg = appBackgroundColor;
  const isCircular = borderRadius === "50%";

  const outerShellSx = isCircular
    ? {
        width: size,
        height: size,
        borderRadius: "50%",
        bgcolor: logoCanvasBg,
        border: `1px solid ${uiNeutrals.wellBorder}`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
      }
    : {
        width: size,
        height: size,
        borderRadius,
        bgcolor: logoCanvasBg,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        overflow: "hidden",
      };

  if (isCircular) {
    return (
      <Box sx={{ ...outerShellSx, ...sx }} {...props}>
        {hasLogo ? (
          <Box
            sx={{
              width: `${CIRCULAR_LOGO_INSET_RATIO * 100}%`,
              height: `${CIRCULAR_LOGO_INSET_RATIO * 100}%`,
              borderRadius: "50%",
              overflow: "hidden",
              bgcolor: logoCanvasBg,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Box
              component="img"
              src={resolvedSrc}
              alt={`${restaurantName} logo`}
              loading={loading}
              sx={{
                width: `${CIRCULAR_LOGO_IMAGE_SCALE * 100}%`,
                height: `${CIRCULAR_LOGO_IMAGE_SCALE * 100}%`,
                objectFit: "contain",
                transition: "opacity 0.3s ease",
                opacity: logoLoaded ? 1 : 0,
              }}
              onLoad={() => setLogoLoaded(true)}
              onError={() => setFailed(true)}
            />
          </Box>
        ) : null}
      </Box>
    );
  }

  if (!hasLogo) {
    return <Box sx={{ ...outerShellSx, ...sx }} {...props} />;
  }

  return (
    <Box sx={{ ...outerShellSx, ...sx }} {...props}>
      <Box
        component="img"
        src={resolvedSrc}
        alt={`${restaurantName} logo`}
        loading={loading}
        sx={{
          width: typeof size === "number" ? size * 0.9 : "80%",
          height: typeof size === "number" ? size * 0.9 : "80%",
          objectFit: "contain",
          transition: "opacity 0.3s ease",
          opacity: logoLoaded ? 1 : 0,
        }}
        onLoad={() => setLogoLoaded(true)}
        onError={() => setFailed(true)}
      />
    </Box>
  );
};

export default RestaurantItemImage;
